export default __webpack_public_path__ + "images/11.ae506dd.png";